export default __webpack_public_path__ + "static/montserrat-v14-latin-300-ea303695ceab35f17e7d062f30e0173b.woff";